<template>
  <div id="form-cta"
    :class="[
      'container-' + organism.containerWidth,
      organism.removeMargin,
      'organism form-cta bg-bc-gray',
    ]"
  >
    <div
      class="content max-w-[1220px] mx-auto flex flex-wrap xl:flex-nowrap gap-10 justify-center items-start pt-20 pb-10 px-8"
    >
      <img
        class="rounded-full object-cover object-[60%_50%] w-[240px] aspect-square bg-gradient-to-b to-[#CCB59F] from-[#E1DBD4] border border-gray-400"
        v-bind="useResponsiveImage(organism.image, null, '240px')"
      />
      <div class="text max-w-[min(400px,_100%)]">
        <h2
          class="mb-7 font-archer font-semibold text-3xl md:text-[40px] leading-none text-gray-800"
        >
          {{ organism.title1 }}
        </h2>
        <div
          class="text-lg text-gray-500 description font-arial"
          v-html="organism.description"
        ></div>
      </div>
      <div class="form w-full max-w-[522px]">
        <header
          v-if="organism.formHeader"
          v-html="organism.formHeader"
          class="mb-4"
        ></header>
        <FormsHubSpotForm :form="form" />
      </div>
    </div>
  </div>
</template>

<style>
.form-cta {
  .text {
    h2 {
      @apply mb-2 max-w-full;
    }

    h3 {
      @apply font-archer text-2xl text-gray-800 font-semibold;
    }

    p {
      @apply mb-4 leading-tight;
    }

    a {
      @apply text-bc-dark-blue;
    }

    ul {
      @apply pl-8 pb-5;
    }

    .icon {
      @apply relative;

      &::before {
        @apply absolute w-5 h-5 -left-8 top-[1px];
      }

      &.icon-phone::before {
        content: url("/img/heroicon-phone.svg");
      }

      &.icon-home::before {
        content: url("/img/heroicon-home.svg");
      }

      &.icon-link::before {
        content: url("/img/heroicon-link.svg");
      }
    }
  }

  form {
    input[type="text"] {
      @apply border border-gray-400 col-span-2 md:col-span-1;

      &::placeholder {
        @apply text-sm;
      }
    }
    select {
      @apply border border-gray-400 col-span-2 text-sm text-gray-500;
    }
    textarea {
      @apply border border-gray-400;

      &::placeholder {
        @apply text-sm;
      }
    }
  }
}
</style>

<script setup>
const props = defineProps({
  organism: Object,
});

const form = computed(() => {
  return {
    id: props.organism?.hubspotFormId,
    hiddenFields: props.organism?.hiddenFormFields ?? [],
  };
});

onMounted(() => {
  if (props.organism.containerWidth === "full-width") {
    addFullWidthSupport();
  }
});
</script>
